import { Component, HostListener, OnDestroy } from '@angular/core';
import { UserAuthenticationService } from './services/shared/userAuthentication.service';
@Component({
  selector: 'netid-app',
  template: require('./app.component.html'),
  styles: [require('./app.component.less').toString()],
})
export class AppComponent implements OnDestroy {
  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    this.userAuthenticationService.Logout();
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event) {
    // ...
  }

  constructor(public userAuthenticationService: UserAuthenticationService) {}
  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts